import React, { useEffect, useState, useRef, useCallback } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { AgGridReact } from 'ag-grid-react';
import moment from 'moment';
import { SBGrid } from "../../../UiComponents/SBAAGgrid";

import { UrlPath } from "../../../../config/routeConfig";
import { BreadCrumbs } from "../../../shared/breadCrumbs/BreadCrumbs";
import { TopBar } from "../../../shared/topBar/TopBar";
import {LoadingScreen} from '../../../UiComponents/LoadingComponent';
import { getAllMarketDataIndices } from '../../../actions/marketDataAction';
import { exportToExcelUsingRef } from "../../../utils/excelExporter";
import download from '../../../../Images/download.svg';
import { setActiveSubMenu } from "../../../actions/CommonAction";
import { getCustomSettings } from "../../../../config/apiConfig";
import { sbaAxios } from "../../../utils/sbaAxios";
export const MarketDataList = () => {
    const dispatch = useDispatch();
    const history = useNavigate();
    const Gstate = useSelector(state => state);    
    const marketlistdata = Gstate.Marketdata.Indices;
    const isEditable =Gstate.authorizationData.isEditable;
    const [colDef, setColDef] = useState();
    const [appliedFilter, setAppliedFilter] = useState(null);
    const gridApi = useRef();
    useEffect(() => {
        document.title = `Market Data`;
        fetchGridData();
   },[]);
   

    useEffect(() => { dispatch(getAllMarketDataIndices()); }, []);
    
    const defaultColDef = {
        sortable: true, filter: true, flex: 1, floatingFilter: true,
    };
    const getDateFormatted=(params)=>{
        const isoDate = params.value;
        const formattedDate = moment(isoDate).format('MM-DD-YYYY');
        return formattedDate;
    };
    const HyperlinkRenderer = (props) => {
        const handleLinkClick = (event) => {
          dispatch(setActiveSubMenu(6,40));
          event.stopPropagation();
        };
        const mktdetails = props.data.MarketIndexId;
        return (
          <Link to={`${UrlPath.MarketDataDetails}${mktdetails}`} onClick={handleLinkClick}>
            {props.value}
          </Link>
        );
      };
      const Addnavigate=()=>
      {
        history(`${UrlPath.MarketDataAdd}`);
      }
    const columnDefs = [
        { field: "MarketIndexName", headerName: "Name",  cellRenderer: HyperlinkRenderer,  filter: "agTextColumnFilter"},
        { field: "MarketIndexShortName", headerName: "Symbol",filter: "agTextColumnFilter" },
        { field: "MarketIndexType", headerName: "Type" ,filter: "agTextColumnFilter"},
        { field: "DataSourceName", headerName: "Source",filter: "agTextColumnFilter" },
        { field: "StartDate", headerName: "Start Date" , valueFormatter: getDateFormatted,filter: "agTextColumnFilter"},
        { field: "EndDate", headerName: "End Date" , valueFormatter: getDateFormatted,filter: "agTextColumnFilter"}
    ];


    const getCustomSetting = async () => {
        try {
            const response = await sbaAxios({ url: `${getCustomSettings}${1018}` });
            if (response) {

                const apiColDef = JSON.parse(response.CustomSettingsValue);
                const apiFilters = JSON.parse(response.CustomFilterValue);
                const formattedDef = apiColDef.map(item => ({
                    ...item,
                    "field": item.colId,
                    valueFormatter: ["StartDate", "EndDate"].includes(item.colId) ? getDateFormatted : null,
                    cellRenderer: (item.colId === "MarketIndexName"
                            ? HyperlinkRenderer
                            : " "

                        ),
                        "headerName": item.colId === "MarketIndexName" ? "Name" : item.colId === "MarketIndexShortName" ? "Symbol" : item.colId === "MarketIndexType" ? "Type":item.colId === "DataSourceName" ? "Source" :null,
                }));
                return { columns: formattedDef, filters: apiFilters };
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    };

    const fetchGridData = async () => {
        try {
            const customSettings = await getCustomSetting();
            setColDef(customSettings.columns);
            setAppliedFilter(customSettings.filters);
        } catch (error) {
            console.error("Error fetching custom settings:", error);
        }
    };

    const Level = [{ BreadCrumb: "Market Data", Routes: `${UrlPath.MarketData}` }];
    return <div id="marketDataList">
         <TopBar label={'Market Data'}/>
        <BreadCrumbs Levels={Level} />
        <div className="container-fluid">
        <div>
              <div className="d-flex justify-content-end gap-2">
                    <button type="submit" className="p-sm-btn mx-1"onClick={Addnavigate} disabled={!isEditable}><i className="fa-solid fa-plus" />Add</button>
                <button type="button" className="p-sm-btn mx-1" onClick={() => { exportToExcelUsingRef(gridApi, "Market Data List.xlsx") }}><img src={download} alt="" />Export</button>
              </div>
        </div>
            <div >

                <SBGrid ref={gridApi} column={colDef} row={marketlistdata} filters={appliedFilter} componentID={1018} gridStyle={{ width: '100%', height: '70vh' }}></SBGrid>

            
        </div>
        </div >
    </div>
}